import { serviceName } from '../resources/serviceConstants';
import {
  GET_CLOSURE_REPORT,
  GET_STAFFING_PENDING_POSITIONS,
  GET_LOST_DROPPED_OVERVIEW,
  GET_SALES_MEMBER_OVERVIEW,
  GET_PENDING_ONBOARDING_REPORT,
  GET_DELIVERY_MANAGER_OVERVIEW,
  OVERALL_REPORT,
} from '../resources/endPoint';

const buildQueryParams = ({ startDate, endDate, dealType }) => {
  const params = [];

  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);

  if (Array.isArray(dealType) && dealType.length > 0) {
    dealType.forEach(dt => {
      params.push(`dealType=${dt}`);
    });
  }

  return params.length ? `?${params.join('&')}` : '';
};

export const getClosureReport = (data) => {
  const { startDate, endDate, dealType } = data;
  const url = `${GET_CLOSURE_REPORT}${buildQueryParams({ startDate, endDate, dealType })}`;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const getPendingPositionsReport = (startDate, endDate, dealType) => {
  const url = `${GET_STAFFING_PENDING_POSITIONS}${buildQueryParams({ startDate, endDate, dealType })}`;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const addEditPendingPositionsReport = (data) => {
  return {
    url: GET_STAFFING_PENDING_POSITIONS,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const getLostDroppedReport = (startDate, endDate, dealType) => {
  const url = `${GET_LOST_DROPPED_OVERVIEW}${buildQueryParams({ startDate, endDate, dealType })}`;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const getSalesMemberWiseReport = (startDate, endDate, dealType) => {
  const url = `${GET_SALES_MEMBER_OVERVIEW}${buildQueryParams({ startDate, endDate, dealType })}`;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const getPendingOnboardingReport = (startDate, endDate, dealType) => {
  const url = `${GET_PENDING_ONBOARDING_REPORT}${buildQueryParams({ startDate, endDate, dealType })}`;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const getDeliveryManagerWiseReport = (startDate, endDate, dealType) => {
  const url = `${GET_DELIVERY_MANAGER_OVERVIEW}${buildQueryParams({ startDate, endDate, dealType })}`;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const getOverallReport = (data) => {
  const { dealType, startDate, endDate, shortNameofReports = [] } = data;

  let url = `${OVERALL_REPORT}?`;

  const queryParams = [];

  if (dealType) queryParams.push(`dealType=${dealType}`);
  if (startDate) queryParams.push(`startDate=${startDate}`);
  if (endDate) queryParams.push(`endDate=${endDate}`);

  shortNameofReports.forEach(report => {
    queryParams.push(`reportsType=${report}`);
  });

  url += queryParams.join('&');

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};
